import { render, staticRenderFns } from "./EpwinSystemTypesDashboardSlider.vue?vue&type=template&id=8417beac&"
import script from "./EpwinSystemTypesDashboardSlider.vue?vue&type=script&lang=js&"
export * from "./EpwinSystemTypesDashboardSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports